<template>
  <a-modal :width="640" title="新增MRD" :visible="visible" :confirm-loading="loading" @cancel="onClose" @ok="onSubmit">
    <a-form-model ref="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" :model="form" :rules="rules">
      <a-form-model-item ref="title" label="标题" prop="title">
        <a-input v-model.trim="form.title" placeholder="请输入标题(最多支持50个字符)" :max-length="50" />
      </a-form-model-item>
      <a-form-model-item v-if="showBusinessRequirementSelect === true" ref="businessRequirementId" label="关联需求" prop="businessRequirementId">
        <business-requirement-select ref="bssReqRef" v-model="form.businessRequirementId" :status="[131]" :item-disabled="true" />
      </a-form-model-item>
      <a-form-model-item ref="template" label="模板">
        <template-select v-model="form.template" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { createDocument } from '@/api/business/document';

import TemplateSelect from '@/pages/business/document/components/TemplateSelect';
import BusinessRequirementSelect from '@/pages/business/document/components/BusinessRequirementSelect';

export default {
  components: { TemplateSelect, BusinessRequirementSelect },
  data() {
    return {
      loading: false,
      visible: false,
      form: {
        title: '',
        template: '',
        businessRequirementId: null
      },
      showBusinessRequirementSelect: true,
      rules: {
        title: [
          { required: true, message: '标题不能为空哦~', trigger: 'change' },
          {
            validator: (_rule, value) => {
              const temp = value.trim();
              if (temp.length === 0) {
                return Promise.reject('标题不能为空哦~');
              }
              if (temp.length < 1 || temp.length > 50) {
                return Promise.reject('标题需要控制在1~50个字以内哦~');
              }
              return Promise.resolve();
            },
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 点击关闭事件
     */
    onClose() {
      this.visible = false;
      this.loading = false;
      this.$refs.form.resetFields();
    },

    /**
     * 点击打开抽屉事件
     */
    onOpen(requirement_id = null) {
      this.visible = true;
      this.$nextTick(() => {
        if (this.$refs.bssReqRef) {
          this.$refs.bssReqRef.init();
        }
      });
      if (requirement_id) {
        this.showBusinessRequirementSelect = false;
      }
      this.form = { title: null, businessRequirementId: requirement_id };
    },

    /**
     * 点击提交事件
     */
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          createDocument({ ...this.form })
            .then(() => {
              this.loading = false;
              this.visible = false;
              this.$message.success('文档创建成功');
              this.$emit('ok');
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
